import lightbox from 'lightbox2'
export default {
  init() {
    // JavaScript to be fired on the single holiday page
    lightbox.option({
      'resizeDuration': 200,
      'wrapAround': true,
    })

    $('.read_more').readmore({
      speed: 1000,
      collapsedHeight: 380,
      heightMargin: 30,
      moreLink: '<span class="btn btn-secondary read-more-btn" href="#">Read More</span>',
      lessLink: '<span class="btn btn-secondary read-more-btn" href="#">Read less</span>',
    })

    $('.display_more').readmore({
      speed: 1000,
      moreLink: '<span class="btn btn-secondary read-more-btn" href="#">Display More</span>',
      lessLink: '<span class="btn btn-secondary read-more-btn" href="#">Display less</span>',
    })

    $('#holiday-date-range-sort-by').on('change', function() {
      const count = $('#holiday-date-range-sort-by').attr('data-count')
      const idx = '#' + $('#holiday-date-range-sort-by').val()
      for (let i = 0; i < count; i++) {
        let id = '#hrange-' + i
        if (id !== idx) {
          if (!$(id).hasClass('holiday-price-range-deselected')) {
            $(id).addClass('holiday-price-range-deselected')
          }

        } else {
          if ($(id).hasClass('holiday-price-range-deselected')) {
            $(id).removeClass('holiday-price-range-deselected')
          }
        }
      }
    })


    if($('#holiday-pricing-block').length) {
      
      jQuery('.single-price-block').each(function(){
        let $this = $(this);
        $this.click(function(){
          if(!jQuery(this).hasClass('open')) {
            jQuery('.single-price-block.open').removeClass('open');
            jQuery(this).addClass('open');
          }
        });
      });
    }


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-holiday.js